import React from 'react';
import { Navigate } from 'react-router-dom';

// login
import Login from '../pages/Authentication/Login';

// User Profile
import UserProfile from '../pages/Authentication/user-profile';

import Organizations from 'pages/Organizations';
import Users from 'pages/Users';
import Properties from 'pages/Properties';
import PropertyDetails from '../pages/Properties/details';
import SubProperties from 'pages/SubProperties';
import ChooseCategory from 'pages/ChooseCategory';
import RegistrationBoard from 'pages/RegistrationBoard';
import Lands from 'pages/Lands';
import LandDetails from 'pages/Lands/details';

const publicRoutes = [
  // Authentication Page
  { path: '/login', component: <Login /> },
];

const authProtectedRoutes = [
  // Organizations
  { path: '/organizations', component: <Organizations /> },
  // Users
  { path: '/organizations/:id/users', component: <Users /> },
  { path: '/organizations/users', component: <Users /> },

  { path: '/organizations/:id/properties', component: <Properties /> },
  { path: '/organizations/properties', component: <Properties /> },

  { path: '/organizations/:id/choose-category', component: <ChooseCategory /> },
  {
    path: '/organizations/:id/registration-board',
    component: <RegistrationBoard />,
  },
  { path: '/organizations/:id/lands', component: <Lands /> },
  {
    path: '/organizations/:organizationId/lands/:id',
    component: <LandDetails />,
  },
  {
    path: '/organizations/:id/registration-board/:trustRegId/lands',
    component: <Lands />,
  },

  { path: '/properties/:id', component: <PropertyDetails /> },
  { path: '/properties/:id/sub-properties', component: <SubProperties /> },
  {
    path: '/properties/:propertyId/sub-properties/:id',
    component: <SubProperties />,
  },

  //User Profile
  { path: '/profile', component: <UserProfile /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: '/',
    exact: true,
    component: <Navigate to="/organizations" />,
  },
  { path: '*', component: <Navigate to="/organizations" /> },
];

export { authProtectedRoutes, publicRoutes };
